import React from "react";
import { withRouter } from "react-router-dom";
import Avatar from "../../components/avatar/Avatar";
import Text from "../../components/typography/Text";
import Tags from "../../components/tags/Tags";
import typesContext from "../../contexts/types";

const Entrepreneur = ({ history, ...project }) => {
  const { skills } = React.useContext(typesContext);
  const { slug, company = "", project_headline, avatar } = project;
  const imageUrl = getImageUrl(project);
  const projectSkills = getProjectSkills(project, skills);
  const isClosed = project.missions_count <= 0;

  const goToProject = () =>
    history.push({
      pathname: `/projects/${slug}`,
      state: { project, redirection: `/projects/${slug}` },
    });

  return (
    <div className="oProject animate__animated animate__fadeIn">
      <div className="oProject_header" onClick={goToProject}>
        <div className="oProject_name">
          <Avatar
            avatar={avatar}
            small
            withPlaceholder
            placeholder={avatar ? null : company[0]}
          />
          <h5>{company}</h5>
        </div>
        {isClosed && <span className="text -small">Closed</span>}
      </div>
      <div
        className="oProject_image"
        onClick={goToProject}
        style={{ backgroundImage: `url(${imageUrl})` }}
      ></div>
      {project?.ecosystem && (
        <div className="oProject_ecosystem">{project.ecosystem}</div>
      )}
      <div className="oProject_title">
        <h4 onClick={goToProject}>{project_headline}</h4>
      </div>

      <div className="oProject_skills">
        <Text superSmall>Skills needed</Text>
        <Tags tags={projectSkills} />
      </div>
    </div>
  );
};

const getImageUrl = project => {
  const { project_image } = project;
  if (project_image?.breakpoints)
    return project_image.base_path + project_image.breakpoints["lg"]["1x"];
  else return project_image;
};

const getProjectSkills = (project, skills) => {
  if (!skills) return [];

  return (
    project?.skill
      ?.map(skillId => {
        const skillData = skills.find(({ id }) => id === parseInt(skillId));
        return skillData ? skillData.name : null;
      })
      .filter(Boolean) || []
  );
};

export default withRouter(Entrepreneur);
